import { graphql } from 'react-relay';

export default graphql`
  query deliveryNotReceivedContextQuery($pdcbr_uuid: String!) {
    deliveryNotReceivedContext(pdcbrUuid: $pdcbr_uuid) {
      recipientInfo {
        firstName
        lastName
        originalPhone
        subscribedPhone
      }
      receivedBy
      shouldConfirmPackageDelivery
      locationCode
      recipientRelationship
      enableComplementaryDeliveryInfoLayout
    }
  }
`;
